<template>
    <router-view/>
</template>
<script>
export default {
    name:'member-layout'
}
</script>